import { Match } from './../interfaces/match';
import { MatchService } from './../core/match.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  matches: Observable<Match[]>;
  selectedGame = 'Pubg Mobile';
  constructor(private matchService: MatchService) {
    this.matches = matchService.getUpcomingMatches(this.selectedGame);
  }

  ngOnInit() {
  }

  changeGame(game) {
    this.selectedGame = game;
    this.matches = this.matchService.getUpcomingMatches(this.selectedGame);
  }

}
